import React from 'react';
import PropTypes from 'prop-types';
import { FaRedoAlt } from 'react-icons/fa';
import { useTranslation } from '@blaze-cms/nextjs-components';
import { TRANSLATION_NAMESPACE } from '../../../constants';

const ResetDesktopForm = ({ handleReset }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  return (
    <div className="filter__reset">
      <button
        type="button"
        className="icon-button icon-button--reset"
        title="reset--button"
        data-testid="reset-icon"
        onClick={handleReset}
        aria-label={t('RESET_ALL_FILTERS')}>
        <i>
          <FaRedoAlt />
        </i>
      </button>

      <div role="button" onClick={handleReset} data-testid="reset-button">
        {t('RESET_ALL_FILTERS')}
      </div>
    </div>
  );
};

ResetDesktopForm.propTypes = {
  handleReset: PropTypes.func.isRequired
};

export default ResetDesktopForm;
